import React, { useState } from 'react';
import Footer from './Footer';

const Projects = () => {
  const [selectedCardId, setSelectedCardId] = useState(null);

  const handleLearnMore = (id) => {
    setSelectedCardId(id);
  };

  return (
    <>
    <div>
        <iframe class="responsive-iframe" src="https://quicklearn-rtu-projects.netlify.app/" width={"100%"} height={"900px"}></iframe>
    </div>

    <Footer/>
    </>
  );
};

export default Projects;
